// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconGrid: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                fill="currentColor"
                d="M4.5 0h-3A1.5 1.5 0 0 0 0 1.5v3A1.5 1.5 0 0 0 1.5 6h3A1.5 1.5 0 0 0 6 4.5v-3A1.5 1.5 0 0 0 4.5 0m8 8h-3A1.5 1.5 0 0 0 8 9.5v3A1.5 1.5 0 0 0 9.5 14h3a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12.5 8m0-8h-3A1.5 1.5 0 0 0 8 1.5v3A1.5 1.5 0 0 0 9.5 6h3A1.5 1.5 0 0 0 14 4.5v-3A1.5 1.5 0 0 0 12.5 0m-8 8h-3A1.5 1.5 0 0 0 0 9.5v3A1.5 1.5 0 0 0 1.5 14h3A1.5 1.5 0 0 0 6 12.5v-3A1.5 1.5 0 0 0 4.5 8"
            />
        </svg>
    );
};

export default React.memo(IconGrid);
